/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch, Button } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import { useDeleteUserByIdMutation, useLazyGetCustomerQuery, useUpdateStatusMutation } from "../../services/customer";
import { showError, showToast } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";
import { isValidInput } from "../../utils/validations";
import CustomToggle from "../../helpers/CustomToggle";
const SubadminList = () => {

    
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    const [getSubAdmin] = useLazyGetCustomerQuery()
    const [updateSubAdmin] = useUpdateStatusMutation()
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const [roleData, setRoleData] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [deleteSub] = useDeleteUserByIdMutation();
    const [selectedId, setSelectedId] = useState("");
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [deleteSubAdmin] = useDeleteUserByIdMutation()
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
    const [updatedStatus] = useUpdateStatusMutation()


    const fetchSub = async () => {
        setLoading(true)
        try {
            const response = await getSubAdmin({
                from: page,
                size: pageSize,
                search: debouncedSearchTerm,
                role: "SUB_ADMIN"
            }).unwrap();

            if (response?.statusCode === 200) {
                setRoleData(response.data.data || []);
                setTotalCount(response.data.total || 0);
            }
        } catch (error: any) {
            showError(error?.data?.message || "Failed to fetch SubAdmin");
        }
        finally {
            setLoading(false)
        }
    };
    const toggleStatus = async (id: string, nextActive: boolean) => {
        try {
            const response = await updatedStatus({
                id,
                body: { isBlocked: !nextActive },
            }).unwrap();

            if (response?.statusCode === 200) {
                showToast(`SubAdmin ${nextActive ? "activated" : "deactivated"} successfully`);
                fetchSub();
            } else {
                showError("Failed to update SubAdmin status");
            }
        } catch (error: any) {
            showError(error?.data?.message || "Failed to update Role status");
        }
    };
    const deleteSubAdminApi = async (id: string) => {
        setLoading(true);
        try {
            const response = await deleteSubAdmin({
                id: selectedId,
            }).unwrap();
            setLoading(false);
            if (response?.statusCode === 200) {
                showToast(response?.message || "SubAdmin Deleted Successfully");
                fetchSub();
            }
        } catch (error: any) {
            showError(error?.data?.message || "");
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchSub()
    }, [page, pageSize, searchTerm])
    const mappedRows = roleData?.map((item: any) => ({
        id: item?._id,
        image: item?.image,
        name: [item?.firstName,].filter(Boolean).join(" ") || item?.email || "",
        email: item?.email,
        phone: item?.phoneNumber,
        role: item?.role,
        date: item?.createdAt ? new Date(item.createdAt).toLocaleDateString() : "",
        isBlocked: Boolean(item?.isBlocked),
        status: !Boolean(item?.isBlocked),
    })) || [];

    const columns: GridColDef<any>[] = [
        {
            flex: 1,
            minWidth: 180,
            field: "name",
            headerName: "Name",
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div className="user_block click_action" onClick={() => navigate(`/manage-subadmin/detail/${params?.row?.id}`)}>
                        <figure>
                            <img src={params?.row?.image || "/static/images/user_placeholder.png"} alt="" />
                        </figure>
                        <p><b>{params?.row?.name || "-"}</b></p>
                    </div>
                )
            }
        },
        {
            flex: 1,
            minWidth: 180,
            field: "email",
            headerName: "Email",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 180,
            field: "phone",
            headerName: "Phone Number",
            editable: false,
            sortable: false,
        },
        // {
        //     flex: 1,
        //     minWidth: 150,
        //     field: "role",
        //     headerName: "Role",
        //     editable: false,
        //     sortable: false,
        // },
        {
            flex: 1,
            minWidth: 150,
            field: "date",
            headerName: "Created Date",
            editable: false,
            sortable: false,
        },
        {
            flex: 1,
            minWidth: 100,
            field: "status",
            headerName: "Status",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <CustomToggle
                        checked={params.value}
                        onChange={() => toggleStatus(params.row.id, !params.value)}
                        id={params.row.id}
                    />
                )
            }
        },
        {
            minWidth: 130,
            field: "action",
            headerName: "Action",
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div className="table_actions v2">
                        <Box>
                            <IconButton onClick={() => navigate(`/manage-subadmin/detail/${params?.row?.id}`)}>
                                <img src="/static/images/eye_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton onClick={() => navigate(`/manage-subadmin/edit/${params?.row?.id}`)}>
                                <img src="/static/images/edit2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton onClick={() => {
                                setOpen(true)
                                setSelectedId(params?.row?.id)
                            }}>
                                <img src="/static/images/trash2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                    </div>
                )
            }
        }
    ];
    let hidden = ["fullName"];
    return (
        <>
            <div className="table_header">
                <div className="left_s">
                    <Box className="search_box">
                        <SearchBar
                            placeholder="Search..."
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setDebouncedSearchTerm}
                            value={searchTerm}
                            onCross={() => setSearchTerm("")}
                            onChange={(val: any) => {
                                if (isValidInput(val.target.value)) {

                                    setSearchTerm(val.target.value);
                                }
                            }}
                        />
                    </Box>
                </div>
                <div className="right_s">
                    <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/roles")}>Manage Roles</Button>
                    <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/add")}><AddIcon /> Add Sub-Admin</Button>
                </div>
            </div>
            <div className="sorting_table">
                <TableComponent
                    columns={columns?.filter((item) => !hidden.includes(item.field))}
                    rows={mappedRows}
                    count={totalCount}
                    page={page}
                    onPageChange={(e: any, newPage: number) => setPage(newPage)}
                    loading={loading}
                    getRowId={(row: any) => row.id}
                />
                <ConfirmationModal
                    text={"Are you sure you want to delete this SubAdmin?"}
                    openModal={open}
                    setOpenModal={setOpen}
                    handleSubmit={() => deleteSubAdminApi(selectedId)}
                />
            </div>
        </>
    );
};

export default SubadminList;
